import { useTranslation } from 'react-i18next'
import type { CreemProduct } from '@/api/topup'
import { renderQuota } from '@/utils/quota'

interface CreemProductPickerProps {
  products: CreemProduct[]
  value: string | null
  onChange: (productId: string) => void
}

export default function CreemProductPicker({ products, value, onChange }: CreemProductPickerProps) {
  const { t } = useTranslation()

  if (!products.length) {
    return (
      <div className="text-[13px] text-[#6B7280] py-4 text-center border border-dashed border-[#E2E8F0] rounded-xl">
        {t('tt.topup.noCreemProducts')}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {products.map((p) => {
        const active = value === p.productId
        return (
          <button
            key={p.productId}
            type="button"
            onClick={() => onChange(p.productId)}
            className={`text-left p-4 rounded-xl border transition-all ${
              active
                ? 'border-brand bg-[rgba(79,70,229,0.06)] shadow-sm'
                : 'border-[#E2E8F0] bg-white hover:border-[#C7D2FE]'
            }`}
          >
            <div className="font-semibold text-[#0F172A] mb-1">{p.name}</div>
            <div className="text-[13px] text-[#6B7280]">
              {p.currency || 'USD'} {p.price} → {renderQuota(p.quota)}
            </div>
          </button>
        )
      })}
    </div>
  )
}
